import type { Opportunities } from "../types"

export const opportunities: Opportunities = new Map([
  [
    "0x797DD80692c3b2dAdabCe8e30C07fDE5307D48a9",
    { cozy: { safetyModule: "0xa1075fC5eF0fa5521D13B0EB6609138d736c1B5D" } },
  ],
])
